export default function PHP_Variables() {
  return (
    <div>
      <h1>PHP_Variables</h1>
    </div>
  );
}
